import { createFileRoute } from '@tanstack/react-router'
import { DocumentsContainer } from 'pages/documents/DocumentsContainer'
import { z } from 'zod'

const documentsSearchSchema = z.object({
  documentID: z.string().optional(),
  pageNumber: z.number().optional(),
  selectedBoxes: z.array(z.string()).optional(),
})

export const Route = createFileRoute('/documents/$siteID')({
  component: RouteComponent,
  validateSearch: documentsSearchSchema,
  staticData: {
    layout: {
      enableScrolling: false,
      enforceMaxWidth: false,
    },
  },
})

function RouteComponent() {
  return <DocumentsContainer />
}
